import { useGlobalStore } from "@/stores";

export const useDirection = () => {
  const { intlService } = useGlobalStore();

  return intlService.direction;
};
